<template>
    <div class="studio_nav_content">
        <el-card shadow="never">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row>
                    <el-col :span="8" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" class="mb0">
                        <el-form-item label="学科">
                            <el-select clearable @change="getList" v-model="queryParams.subjectKey" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt15">
                    <el-col :span="8" class="mb0">
                        <el-form-item label="类型">
                            <el-select @change="getList" v-model="queryParams.collectType" placeholder="请选择">
                                <el-option :label="'资源中心'" :value="'1'" />
                                <el-option :label="'师资培训'" :value="'0'" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8"></el-col>
                    <el-col :span="8" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.courseName" placeholder="请输入课程名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />

            <el-row style="height:calc(100vh - 260px);overflow-y: auto;" v-loading="loading">
                <el-col class="w-90" v-for="(item, index) in dataList" :key="index" :xs="12" :sm="12" :md="12" :lg="8">
                    <el-card @click="handleLookVideo(item)" :body-style="{ padding: '0px' }">
                        <div class="btnStart" style="display: flex;position: relative;">
                            <div style="padding:14px 0px 10px 14px;position: relative;">
                                <img style="width:110px;height: 95px;object-fit: cover;" :src="item.courseCover" alt=""
                                     class="image">
                            </div>
                            <div style="padding: 16px 10px 10px 10px" class="fs-14 wbba">
                                <div style="display: flex;" class="mb5">
                                    <div class="wh-sp-now">课程名称：</div>
                                    <div :title="item.courseName" class="text-one">{{ item.courseName }}</div>
                                </div>
                                <div style="display: flex;" class="mb5">
                                    <div class="">{{ item.periodName }}-{{ item.gradeName }}-{{ item.subjectName }}</div>
                                </div>
                                <!-- <div style="display: flex;" class="mb5">
                                    <div class="wh-sp-now">年级：</div>
                                    <div class=""></div>
                                </div>
                                <div style="display: flex;" class="mb5">
                                    <div class="wh-sp-now">学科：</div>
                                    <div class=""></div>
                                </div> -->
                                <div style="display: flex;" class="mb5">
                                    <div :title="item.courseRecommend" class="text-two">视频介绍：{{ item.courseRecommend }}
                                    </div>
                                    <!-- <div :title="item.courseRecommend" class="text-two">
                                    {{ item.courseRecommend }}</div> -->
                                </div>
                            </div>

                            <!-- <div class="start" style="position: absolute;right: 0;top:0;padding: 10px;background: #f1f1f1;">
                                <el-icon @click.stop="delFile(item)" title="删除">
                                    <Delete />
                                </el-icon>
                                <el-icon @click.stop="downloadFile(item)" title="下载" class="ml10">
                                    <Download />
                                </el-icon>
                            </div> -->
                        </div>
                        <div class="mb15" style="display: flex;justify-content: space-around;align-items: center;">
                            <div class="stpBox">
                                <img class="mr10" style="width: 16px;height:16px" src="../../assets/image/dz.png" alt="">
                                {{ item.courseCount }}
                            </div>
                            <div class="stpBox">
                                <el-icon class="mr10">
                                    <Star />
                                </el-icon>
                                {{ item.collectCount }}
                            </div>
                            <div class="stpBox">
                                <el-icon class="mr10">
                                    <View />
                                </el-icon>
                                {{ item.viewCount }}
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-empty style="margin: 0 auto;padding-top: 10vh;" v-if="dataList.length == 0" :image-size="200" />
            </el-row>
        </el-card>
    </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { famousCourseListReleaseCourse } from '@/api/admin/famousCourse';
import { lessonListCommonLessons, lessonSubmit, delLessonFile, lessonStop, lessonRelease } from "@/api/admin/lesson"
import { timestampToTime } from "@/utils/date";
import { queryDict } from "@/api/admin/public";
import { download } from "@/api/adminservice/public";
import { collectList } from "@/api/admin/famousCourse";

export default {
    name: "scenarioMain",
    components: {
    },
    data() {
        return {
            subjectList: [],
            periodList: [],
            gradeList: [],
            gAFileList: [],
            token: this.$storage.get("token"),
            roleList: [
                { name: '已参与', value: 1 },
                { name: '未参与', value: 2 },
            ],
            timestampToTime,
            // 遮罩层
            loading: true,
            // 选中数组
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            isFilter: true,
            // 总条数
            total: 0,
            taskdata: {},
            // 基础：基数数据表格数据
            dataList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                role: '',
                courseName: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                stageType: '',
                collectType: '',
            },
            courseClassifyList: [],
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" }
                ],
                values: [
                    { required: true, message: "请输入内容", trigger: "blur" }
                ]
            },
            selectObj: []
        };
    },
    created() {
        this.getQueryDict()
        this.getList();
    },
    activated() {
        if (this.$route.query.isSx == 1) {
            this.getList();
        }
    },
    watch: {},
    methods: {
        delFile(item) {
            var _this = this;
            ElMessageBox.confirm(
              '是否删除该共享课件?',
              '删除',
              {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              }
            ).then(() => {
                let arr = []
                item.jaFiles.forEach(e => {
                    arr.push(new Promise(function (resolve, reject) {
                        delLessonFile({ fileUrl: e.fileUrl }).then(res => {
                            resolve(res.data.code)
                        })
                    }))
                })
                item.xaFiles.forEach(e => {
                    arr.push(new Promise(function (resolve, reject) {
                        delLessonFile({ fileUrl: e.fileUrl }).then(res => {
                            resolve(res.data.code)
                        })
                    }))
                })
                item.xtFiles.forEach(e => {
                    arr.push(new Promise(function (resolve, reject) {
                        delLessonFile({ fileUrl: e.fileUrl }).then(res => {
                            resolve(res.data.code)
                        })
                    }))
                })
                item.kjFiles.forEach(e => {
                    arr.push(new Promise(function (resolve, reject) {
                        delLessonFile({ fileUrl: e.fileUrl }).then(res => {
                            resolve(res.data.code)
                        })
                    }))
                })
                Promise.all(arr).then((result) => {
                    _this.getList()
                })

            }).catch(() => {

            })

            console.log(item);
        },
        handleLookVideo(row) {
            if (this.queryParams.collectType == 1) {
                const path = 'homeResourceCentre';
                //参数传递
                this.$store.commit("params/setJumpParams",
                  {activePath:path,activeItem: '99',courseId:row.courseId});
                this.$router.push({path: "/hyedu/resource"});

            }else{
                const path = 'homeResourceCentre';
                //参数传递
                this.$store.commit("params/setJumpParams",
                  {activePath:path,activeItem: '99',courseId:row.courseId});
                this.$router.push({path: "/hyedu/resource"});
            }

        },
        downloadFile(item) {
            item.jaFiles.forEach(e => {
                download(e.fileUrl, e.fileName)
            })
            item.xaFiles.forEach(e => {
                download(e.fileUrl, e.fileName)
            })
            item.xtFiles.forEach(e => {
                download(e.fileUrl, e.fileName)
            })
            item.kjFiles.forEach(e => {
                download(e.fileUrl, e.fileName)
            })
            console.log(item);
        },
        lessonFileGADetail(item) {
            console.log(item);
            let routeUrl = this.$router.resolve({
                path: '/lessonFileGADetail',// 这里的路径就可以正常的写，不需要添加_blank: true
                query: { lessonId: item.lessonId }
            })
            window.open(routeUrl.href, '_blank')
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'famous_course_classify' }).then(res => {
                this.courseClassifyList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.getList()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.getList()
        },
        handleGAChange(e) {
            console.log(e)
            if (e.response) {
                if (e.response.code == 1) {
                    this.$message.success('上传成功')
                    this.getList();
                } else {
                    this.$message.error('上传失败')
                }
            }

            // this.gAFileList = [];
        },
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        handleGA(row) {

        },
        handleCurrentChange(val) {
            console.log(val)
            this.selectObj = val;
        },
        handleSelectionChange(val) {
            console.log(val)
            this.selectList = val;
        },
        tgMethod(e) {
            this.queryParams.screenName = '';
            this.open = false;
            this.taskdata = {};
            this.getList();
        },
        /** 查询基础：基数数据列表 */
        getList() {
            this.dataList = [];
            collectList({ collectType: null }).then(res => {
                if (this.queryParams.periodKey != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.periodKey == this.queryParams.periodKey
                    })
                }
                if (this.queryParams.stageType != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.stageType == this.queryParams.stageType
                    })
                }
                if (this.queryParams.gradeKey != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.gradeKey == this.queryParams.gradeKey
                    })
                }
                if (this.queryParams.subjectKey != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.subjectKey == this.queryParams.subjectKey
                    })
                }
                if (this.queryParams.courseName != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.courseName.toString().indexOf(this.queryParams.courseName) != -1
                    })
                }
                if (this.queryParams.collectType != '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.course.courseType == this.queryParams.collectType
                    })
                }
                res.data.data.forEach(e => {
                    this.dataList.push(e.course)
                })
                this.loading = false;
            });
        },

        // 表单重置
        reset() {
            this.form = {
                did: null,
                type: null,
                title: null,
                values: null,
                px: null,
                createTime: null,
                updateTime: null,
                delFlag: null
            };
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.$refs['queryForm'].resetFields()
            this.handleQuery();
        },
        handleRelease(row) {
            lessonRelease({ lessonId: row.lessonId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("发布成功");
                    this.getList();
                } else {
                    this.$message.error("发布失败");
                }
            })
        },
        handleSubmit(row) {
            console.log(row)
            if (row.jaFiles.length == 0 && row.kjFiles.length == 0 && row.xtFiles.length == 0) {
                this.$message.error("请先上传文件");
                return
            }
            lessonSubmit({ lessonId: row.lessonId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("提请成功");
                    this.getList();
                } else {
                    this.$message.error("提请失败");
                }
            })
        },
        handleStop(row) {
            lessonStop({ lessonId: row.lessonId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("停止成功");
                    this.getList();
                } else {
                    this.$message.error("停止失败");
                }
            })
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.$router.push({
                path: "/lessonAdd",
                query: {
                    lessonId: row.lessonId,
                }
            });
        }
    }
};
</script>
<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}

.zzzdddyyy /deep/ .el-upload-list {
    margin: 0 !important;
}

.zzzdddyyy /deep/ .el-upload-list__item {
    display: none;
}

.pxbutton {
    width: 90px;
    padding: 7px 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    font-size: 13px;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.w-90 {
    margin-bottom: 15px;
    margin-top: 10px;
}

.w-90 /deep/ .el-card.is-always-shadow {
    width: 90%;
    margin: 0 auto;
    cursor: pointer;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.image {
    width: 100%;
    display: block;
}

.chosebtn {
    padding-top: 10px;
    display: flex;
    /* justify-content: space-around; */
    align-items: center;
}

.chosebtn div {
    margin-right: 10px;
}

.chosebtn img {
    padding: 5px;

    margin: 0 auto;
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.bor-lan {
    border: 1px solid #409eff
}

.wbba {
    word-break: break-all;
}

.sssstt /deep/ .el-scrollbar__view {
    display: block !important;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}

.pxbutton {
    padding: 7px 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    font-size: 13px;
}

.start {
    display: none;
}

.btnStart:hover .start {
    display: block;
}

.cjtag {
    position: absolute;
    top: 14px;
    right: 0;
    font-size: 14px;
    background: #f1f1f1;
    padding: 2px 7px;
    border-radius: 4px;
    color: #d44c2d;
}

.stpBox {
    display: flex;
    align-items: center;
}
</style>